module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pause-serve-header"
  }, [_c('div', [_c('logo-in-header', {
    staticClass: "pause-serve-logo",
    attrs: {
      "link-to-home": false,
      "color": 'white',
      "box-height": 1,
      "font-size": 1.7
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-5dd81a72!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/plexHeader/pauseServerHeader.vue
// module id = 1332
// module chunks = 1